import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '夏からでも志望校合格は間に合いますか？',
      answer:
        'はい、間に合います。当塾では夏からの入塾生も多く、効率的なカリキュラムで志望校合格を実現しています。受験までの期間を逆算し、優先順位をつけた学習計画を立てますので、ご安心ください。',
    },
    {
      question: '内申点は本当に上がりますか？',
      answer:
        '定期テスト対策と提出物管理を徹底することで、内申点アップを実現しています。過去の実績では、平均6.2点の内申点アップを達成しています。',
    },
    {
      question: '個別指導と集団指導、どちらが良いですか？',
      answer:
        '当塾では両方の良さを組み合わせたハイブリッド型指導を採用しています。個別指導で弱点を克服し、集団指導で競争心を育てることで、最大の学習効果を実現します。',
    },
    {
      question: '無料体験はどのような内容ですか？',
      answer:
        '実際の授業を1週間無料で体験できます。学力診断テストを実施し、現在の学力と志望校までの距離を明確にした上で、最適な学習プランをご提案します。',
    },
    {
      question: '他の塾との違いは何ですか？',
      answer:
        '当塾の最大の特徴は、内申点対策と受験対策を両立できる点です。定期テスト2週間前からは完全にテスト対策モードに切り替え、学校の成績アップを徹底サポートします。',
    },
    {
      question: '部活と両立できますか？',
      answer:
        'はい、可能です。部活生専用の時間割を用意しており、19時以降の授業も充実しています。また、振替制度も柔軟に対応していますので、安心して通塾できます。',
    },
    {
      question: '保護者との面談はありますか？',
      answer:
        '希望者には三者面談を実施し、学習状況や進路について詳しくご報告します。',
    },
    {
      question: '入塾テストはありますか？',
      answer:
        '入塾テストはありません。現在の学力に関わらず、やる気のある生徒を全力でサポートします。無料体験時に学力診断を行い、最適なクラスをご提案します。',
    },
  ];

  return (
    <section className="py-16 px-6 bg-[#FAF8F5]">
      <div className="max-w-5xl mx-auto">
        {/* セクションヘッダー */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-black text-[#1A2B4A] mb-4">
            よくある質問
          </h2>
          <p className="text-[#6B7280] text-sm md:text-base leading-relaxed">
            保護者の方からよくいただくご質問にお答えします
          </p>
        </div>

        {/* FAQアコーディオン */}
        <div className="md:grid md:grid-cols-2 md:gap-4 space-y-4 md:space-y-0">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-sm"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-5 py-5 flex items-center justify-between gap-4 text-left hover:bg-[#FAF8F5] transition-colors cursor-pointer"
              >
                <span className="text-[#1A2B4A] font-bold text-[15px] leading-snug flex-1">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-[#6B7280] text-xl transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              {openIndex === index && (
                <div className="px-5 pb-5 bg-[#FAF8F5]">
                  <div className="pt-3">
                    <p className="text-[#6B7280] text-sm leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* もっと詳しくボタン */}
        <div className="text-center mt-12">
          <a
            href="https://29-jyuku.com"
            className="inline-flex items-center gap-2 bg-[#1A2B4A] text-white font-bold text-base md:text-lg px-8 py-4 rounded-full shadow-lg hover:bg-[#1A2B4A]/90 transition-all cursor-pointer whitespace-nowrap"
          >
            <span>もっと詳しく見たい方はこちら</span>
            <i className="ri-arrow-right-line text-xl"></i>
          </a>
          <p className="text-[#6B7280] text-xs mt-3">お電話でお気軽にお問い合わせください</p>
        </div>
      </div>
    </section>
  );
}
